/* eslint-disable no-unused-vars */
import { Grid, CircularProgress } from "@mui/material";
import PDialog from "../../../../components/pos/PDialog";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../../utils/API";
import PurchaseRequestDraftList from "./PurchaseRequestDraftList.jsx";
import PurchaseRequestDraftSummary from "./PurchaseRequestDraftSummary.jsx";
import PurchaseRequestOrderDraftDetails from "./PurchaseRequestOrderDraftDetails.jsx";
import GenericReportViewer from "./../../../reports/GenericReportViewer";
// import PConfirm from "../../../../components/pos/PConfirm";
import PConfirm from "../../../../components/pos/PConfirm";

export default function PurchaseRequestDraftWindow(props) {
  const { t } = useTranslation();
  const translate = t;
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("New Local Purchase Order");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [purchaseItems, setPurchaseItems] = useState([]);
  const [purchaseOrderObj, setPurchaseOrderObj] = useState();
  const [isReturn, setIsReturn] = useState(false);
  const [taxType, setTaxType] = useState({ name: "Include Tax", id: "1" });
  const [taxTypeOptions, setTaxTypeOptions] = useState([]);
  const [totalTax, setTax] = useState(0);
  const [totalWithoutTax, setWithoutTax] = useState(0);
  const [totalWithTax, setWithTax] = useState(0);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  const [discountTypeOptions, setDiscountTypeOptions] = useState([
    { name: "After Tax", id: "1" },
    { name: "Before Tax", id: "2" },
  ]);
  const [selectedDiscountType, setSelectedDiscountType] = useState({
    name: "After Tax",
    id: "1",
  });
  const [subTotalDiscount, setSubTotalDiscount] = useState(0);
  const [invoiceAmount, setInvoiceAmount] = useState(0);
  // const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  var biRef = {};

  props.biRef.draftEntry = {
    showPurchaseRequestDraftWindow: showPurchaseRequestDraftWindow,
  };

  useEffect(() => {
    setTaxTypeOptions([
      { name: "Include Tax", id: "1" },
      { name: "Exclude Tax", id: "2" },
      { name: "No Tax", id: "3" },
    ]);
  }, []);

  function showPurchaseRequestDraftWindow(purchaseorderId, type, isReturnFlag) {
    setOpenWindow(true);
    setIsReturn(isReturnFlag);
    if (purchaseorderId == null) {
      setMode("create");
      setWindowTitile(
        translate("Create ") +
          (isReturnFlag ? translate("Return ") : translate("Local Purchase ")) +
          translate("order")
      );
      resetFields();
    } else if (type == "Edit") {
      // setWindowTitile(
      //   translate("Edit ") +
      //     (isReturnFlag ? translate("Return ") : translate("Local Purchase ")) +
      //     translate("order")
      // );
      setWindowTitile(
        translate("Edit ") +
          (isReturnFlag ? translate("Return ") : translate("Local Purchase ")) +
          translate("order")
      );
      setMode("edit");
      populatePurchaseOrder(purchaseorderId, false);
    } else {
      // setWindowTitile(
      //   translate("View ") +
      //     (isReturnFlag ? translate("Return ") : translate("Local Purchase ")) +
      //     translate("order")
      // );
      setWindowTitile(
        translate("View ") +
          (isReturnFlag ? translate("Return ") : translate("Local Purchase ")) +
          translate("order")
      );
      setMode("view");
      populatePurchaseOrder(purchaseorderId, false);
      // props.showMessage(
      // setMode("view");
      // populatePurchaseOrder(purchaseorderId, false);
      // // props.showMessage(
      //   "error",
      //   translate("Something went wrong! View mode is undefined")
      // );
    }
  }

  function resetFields() {
    setPurchaseOrderObj(null);
    setPurchaseItems([]);
    if (biRef.requestDraftCrud != undefined)
      biRef.requestDraftCrud.parentEvent("resetFileds");
  }

  function onCloseWindow() {
    resetFields();
    setOpenWindow(false);
  }

  function isDataChanged() {
    return false;
  }

  async function populatePurchaseOrder(purchaseOrderId, isSettleFlag) {
    try {
      let { data } = await API.get("/api/v1/purchaseorder/" + purchaseOrderId);
      populateData(data, isSettleFlag);
      setOpenWindow(true);
    } catch (err) {
      props.showMessage(
        "error",
        translate("Not able to retrive purchase order data from server")
      );
    }
  }

  function populateData(inputData, isSettleFlag) {
    taxTypeOptions.map((item) => {
      if (item.id == inputData.taxTypeValue) {
        setTaxType(item);
      }
    });
    setPurchaseOrderObj(inputData);
    /*Populate  table*/
    let sn = 1;
    let data = [];
    inputData.orderItems.map((item) => {
      let orderItem = [
        { v: sn },
        { v: item.productName },
        { v: item.unitType },
        {
          v: isSettleFlag
            ? item.receivedQty
              ? item.receivedQty
              : item.quantity
            : item.quantity,
        },
        {
          v: { foc: item.isIncludeFocQty, focQty: item.focQty },
        },
        {
          v: isSettleFlag
            ? item.receivedNetCost
              ? item.receivedNetCost
              : item.actualCost
            : item.actualCost,
        },
        { v: item.taxPercentage },
        {
          v: isSettleFlag
            ? item.receivedTaxCost
              ? item.receivedTaxCost
              : item.taxCost
            : item.taxCost,
        },
        {
          v: isSettleFlag
            ? item.receivedCostWithoutTax
              ? item.receivedCostWithoutTax
              : item.totalCost
            : item.totalCost,
        },
        {
          v: isSettleFlag
            ? item.receivedNetCost
              ? item.receivedNetCost
              : item.netCost
            : item.netCost,
        },
        {
          info: {
            productBean: item.productBean,
            pricingBean: null,
            selected: false,
          },
        },
      ];
      data.push(orderItem);
      sn++;
    });
    setPurchaseItems(data);
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function saveData(status) {
    var payload = createPayload(status);
    if (payload) {
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/purchaseorder", payload);
        if (status === "DRAFT")
          props.showMessage("success", translate("Request saved as draft"));
        else
          props.showMessage(
            "success",
            translate("Request submitted successfully")
          );
        props.onRefresh();
        showPurchaseRequestDraftWindow(
          result.data.id,
          props.context.privileges.lpo_lro_draft_edit ? "Edit" : "View",
          isReturn
        );
        showProgress(false, "Saving");
        return result.data.id;
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage(
            "error",
            translate("Not able to Save Purchase Order")
          );
        }
      }
    }
    return null;
  }

  async function onSave() {
    saveData("REQUESTED");
  }

  async function onSaveDraftClicked() {
    saveData("DRAFT");
  }

  async function handlePrintClick() {
    let purchaseOrderId = await saveData("REQUESTED");
    if (purchaseOrderId) {
      let paramsList = [
        {
          key: "purchaseOrderId",
          value: purchaseOrderId,
        },
      ];

      biRef.genericReportView.showGenericReportViewer(
        "reports/generic/local_purchase_order",
        paramsList,
        "Purchase Request "
      );
    }
  }

  function showDetailedError(msg) {
    if (biRef && biRef.requestDraftCrud)
      biRef.requestDraftCrud.parentEvent("validation", msg);
    props.showMessage("error", msg.message);
  }

  function createPayload(status) {
    let saveObject = null;
    if (status == "DRAFT")
      saveObject = biRef.requestDraftCrud.parentEvent("getDraftPayload");
    else saveObject = biRef.requestDraftCrud.parentEvent("getPayload");
    if (!saveObject) {
      props.showMessage("error", translate("Validation failed"));
      return null;
    }
    if (
      (status == "SETTLED" || status == "REQUESTED") &&
      purchaseItems.length == 0
    ) {
      props.showMessage("error", translate("No products selected for settle"));
      return null;
    }

    for (let i = 0; i < purchaseItems.length; i++) {
      if (purchaseItems[i][3].v === "" || purchaseItems[i][3].v === "0") {
        props.showMessage(
          "error",
          "Validation failed, Qunatity is worng at row" +
            ":" +
            (parseInt(i) + 1).toString()
        );
        return null;
      }
      if (
        status == "SETTLED" &&
        purchaseItems[i][4].v.foc &&
        purchaseItems[i][4].v.foc == true &&
        (purchaseItems[i][4].v.focQty === "" ||
          parseFloat(purchaseItems[i][4].v.focQty) === 0)
      ) {
        props.showMessage(
          "error",
          "Validation failed, FOC QTY is worng at row" +
            ":" +
            (parseInt(i) + 1).toString()
        );
        return null;
      }

      if (
        status == "SETTLED" &&
        (purchaseItems[i][4].v.foc == null ||
          purchaseItems[i][4].v.foc == false) &&
        (purchaseItems[i][5].v === "" ||
          parseFloat(purchaseItems[i][5].v) === 0)
      ) {
        props.showMessage(
          "error",
          "Validation failed, Cost is worng at row" +
            ":"(parseInt(i) + 1).toString()
        );
        return null;
      }

      if (
        status == "REQUESTED" &&
        (purchaseItems[i][5].v === "" ||
          parseFloat(purchaseItems[i][5].v) === 0)
      ) {
        props.showMessage(
          "error",
          "Validation failed, Cost is worng at row" +
            ":"(parseInt(i) + 1).toString()
        );
        return null;
      }
    }

    saveObject["status"] = status;
    let orderItems = [];
    let count = 0;
    let actualCost = 0;
    let costWithoutTax = 0; //TODO Jestin - populate costWithoutTax
    purchaseItems.map((value) => {
      let ordeItem = Object.create(null);
      // // ordeItem["productBean"] = value[10].info.productBean;
      // ordeItem["productId"] = value[10].info.productBean.id;
      // ordeItem["productBean"] = value[10].info.productBean;
      ordeItem["productId"] = value[10].info.productBean.id;
      ordeItem["productName"] = value[1].v;
      ordeItem["unitType"] = value[2].v;
      ordeItem["quantity"] = value[3].v;
      ordeItem["productPricingId"] = null;
      ordeItem["actualCost"] = value[5].v;
      ordeItem["totalCost"] = value[8].v;
      ordeItem["taxTypeValue"] = taxType.id;
      ordeItem["taxTypeText"] = taxType.name;
      ordeItem["taxPercentage"] = value[6].v;
      ordeItem["taxCost"] = value[7].v;
      ordeItem["netCost"] = value[9].v;
      ordeItem["isSettled"] = false;
      ordeItem["receivedQty"] = 0;
      ordeItem["isIncludeFocQty"] = value[4].v.foc;
      ordeItem["focQty"] = value[4].v.focQty;
      // ordeItem["receivedTaxCost"] = null;
      // ordeItem["receivedCostWithoutTax"] = null;
      // // ordeItem["receivedNetCost"] = value[9].v;
      // // ordeItem["receivedNetCost"] = parseFloat(value[9].v);
      ordeItem["receivedTaxCost"] = null;
      ordeItem["receivedCostWithoutTax"] = null;
      // ordeItem["receivedNetCost"] = value[9].v;
      // ordeItem["receivedNetCost"] = parseFloat(value[9].v);
      orderItems.push(ordeItem);
      count = count + value.receivedQty;
      actualCost = actualCost + value.receivedNetCost;
    });
    saveObject["itemCount"] = count;
    saveObject["actualCost"] = actualCost;
    saveObject["totalExpectedCost"] = actualCost;
    saveObject["taxTypeValue"] = taxType.id;
    saveObject["taxTypeText"] = taxType.name;
    saveObject["orderItems"] = orderItems;
    saveObject["returnFlag"] = isReturn;
    saveObject["orderType"] = isReturn == true ? "LRO" : "LPO";

    if (subTotalDiscount != null && parseFloat(subTotalDiscount) != 0) {
      if (
        parseFloat(subTotalDiscount) >
        (selectedDiscountType.id == "1" ? actualCost : costWithoutTax)
      ) {
        props.showMessage(
          "error",
          "Validation failed discount amount should be less than net amount"
        );
        return null;
      }
    }
    saveObject["subTotalDiscountAmount"] = subTotalDiscount;
    saveObject["discountTypeText"] = selectedDiscountType.name;
    saveObject["discountTypeValue"] = selectedDiscountType.id;
    saveObject["invoiceAmount"] =
      invoiceAmount != null && parseFloat(invoiceAmount) != 0
        ? invoiceAmount
        : actualCost;

    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = purchaseOrderObj.id;
      saveObject["intVersion"] = purchaseOrderObj.intVersion;
    }
    return saveObject;
  }

  // function onDelete() {
  //   setConfirmContext({
  //     title: "Are You Sure",
  //     message: "Are you sure to delete the order,This action can't revert!",
  //     type: "warning",
  //     open: true,
  //     yes: true,
  //     no: true,
  //     confirmContextType: "DELETE",
  //   });
  //   setConfirmOpen(true);
  // }

  // async function onYesNoClicked(context, value, confirmContextType) {
  //   if (value == "yes") {
  //     try {
  //       let result = await API.delete(
  //         "/api/v1/purchaseorder/" + purchaseOrderObj.id
  //       );
  //       props.showMessage("warning", translate("Purchase order got removed"));
  //       setOpenWindow(false);
  //       props.onRefresh();
  //     } catch (err) {
  //       console.log("error", err);
  //       props.showMessage(
  //         "error",
  //         translate("Not able to delete purchase order")
  //       );
  //     }
  //   }
  // }

  function onDelete() {
    setConfirmContext({
      title: "Are You Sure",
      message: "Are you sure to delete the order,This action can't revert!",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      confirmContextType: "DELETE",
    });
    setConfirmOpen(true);
  }

  async function onYesNoClicked(context, value, confirmContextType) {
    if (value == "yes") {
      try {
        let result = await API.delete(
          "/api/v1/purchaseorder/" + purchaseOrderObj.id
        );
        props.showMessage("warning", translate("Purchase order got removed"));
        setOpenWindow(false);
        props.onRefresh();
      } catch (err) {
        console.log("error", err);
        props.showMessage(
          "error",
          translate("Not able to delete purchase order")
        );
      }
    }
  }

  const content = (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={12}>
        <PurchaseRequestOrderDraftDetails
          biRef={biRef}
          purchaseOrderObj={purchaseOrderObj}
        ></PurchaseRequestOrderDraftDetails>
      </Grid>
      <Grid item xs={12} sm={12}>
        <PurchaseRequestDraftList
          data={purchaseItems}
          viewMode={mode}
          updatePurchaseItemData={setPurchaseItems}
          biRef={biRef}
          taxType={taxType}
          setTaxType={setTaxType}
          taxTypeOptions={taxTypeOptions}
          showMessage={props.showMessage}
          context={props.context}
          productCache={props.productCache}
        ></PurchaseRequestDraftList>
      </Grid>
      <Grid item xs={12} sm={12}>
        <PurchaseRequestDraftSummary
          purchaseItems={purchaseItems}
          discountTypeOptions={discountTypeOptions}
          selectedDiscountType={selectedDiscountType}
          subTotalDiscount={subTotalDiscount}
          invoiceAmount={invoiceAmount}
          setInvoiceAmount={setInvoiceAmount}
          setSubTotalDiscount={setSubTotalDiscount}
          setSelectedDiscountType={setSelectedDiscountType}
          totalTax={totalTax}
          setTax={setTax}
          totalWithoutTax={totalWithoutTax}
          setWithoutTax={setWithoutTax}
          totalWithTax={totalWithTax}
          setWithTax={setWithTax}
          productCache={props.productCache}
          context={props.context}
        ></PurchaseRequestDraftSummary>
      </Grid>
    </Grid>
  );

  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"lg"}
          fullWidth={true}
          fullScreen={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          saveLabel={"CREATE"}
          showSaveDraftButton={
            (!props.context.privileges.lpo_lro_draft_edit &&
              props.selectedRowStatus === "DRAFT") ||
            (!props.context.privileges.lpo_lro_requested_edit &&
              props.selectedRowStatus === "REQUESTED") ||
            mode == "view"
              ? mode === "create"
                ? true
                : false
              : true
          }
          onSaveDraftClicked={onSaveDraftClicked}
          onDelete={
            props.context.privileges.lpo_lro_delete &&
            props.selectedRowStatus === "DRAFT"
              ? onDelete
              : false
          }
          mode={mode}
          isDataChanged={isDataChanged}
          showPrint={
            (!props.context.privileges.lpo_lro_draft_edit &&
              props.selectedRowStatus === "DRAFT") ||
            (!props.context.privileges.lpo_lro_requested_edit &&
              props.selectedRowStatus === "REQUESTED") ||
            mode === "view"
              ? mode === "create"
                ? true
                : false
              : true
          }
          onPrint={handlePrintClick}
          printLabel={"Create & Print"}
          hideSave={
            (!props.context.privileges.lpo_lro_draft_edit &&
              props.selectedRowStatus === "DRAFT") ||
            (!props.context.privileges.lpo_lro_requested_edit &&
              props.selectedRowStatus === "REQUESTED") ||
            mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
        ></PDialog>
      )}
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
      ></GenericReportViewer>
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
    </div>
  );
}
